import type { TAvailabilitySlot} from "../../types/availableSlots";
import {parseISO, format, isToday} from 'date-fns';
import clsx from "clsx";
import type { TStore } from "../../types/store";

type TSlotsProps = {
    slots: TAvailabilitySlot[];
    busySlots: TAvailabilitySlot[];
    selectedSlot: TAvailabilitySlot | null;
    onSelect: (slot: TAvailabilitySlot) => void;
    selectedStore: TStore | null;
}

function BookingSlots({slots, busySlots, selectedSlot, onSelect, selectedStore}: TSlotsProps) {
    if(!slots.length) return null;
    const now = new Date();
    const blockedAugustDays = new Set([
        1, 2, 3, 7, 8, 9, 10, 11,
        13, 14, 17, 20, 21, 22,
        23, 24, 27, 28, 29, 30, 31,
    ]);

    const blockedTimes = new Set([
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
    ]);

    return (
        <div className="booking-slots">
            <p className="booking-slots__title booking-title">Выберите время<span>*</span></p>
            <div className="booking-slots-list">
                {slots.map((slot) => {
                    const { timeStart, timeEnd } = slot;

                    const slotStart = parseISO(timeStart);
                    const slotEnd = parseISO(timeEnd);

                    const formattedTime = format(slotStart, 'HH:mm');

                    const isBusy = busySlots.some(
                        (busySlot) => format(parseISO(busySlot.timeStart), 'HH:mm') === formattedTime
                    );

                    const isSelected = selectedSlot?.timeStart === timeStart;

                    const isPast =
                        isToday(slotEnd) &&
                        slotEnd.getTime() < now.getTime();

                    const isAugustBlocked =
                        selectedStore?.store_code === 'Liteyniy' &&
                        slotStart.getMonth() === 7 &&
                        blockedAugustDays.has(slotStart.getDate()) &&
                        blockedTimes.has(formattedTime);

                    const isDisabled =
                        isBusy || isPast || isAugustBlocked;

                    return (
                        <button 
                            key={timeStart}
                            type="button"
                            disabled={isDisabled}
                            className={clsx("booking-slots__slot", {
                                selected: isSelected,
                                disabled: isDisabled,
                            })}
                            onClick={() => onSelect(slot)}
                            >
                                {format(parseISO(timeStart),'HH:mm')}
                        </button>
                    )
                })}
            </div>
        </div>
    );
}

export default BookingSlots;